import { Component, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { sidenavRoutes } from './routes';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-sidenav',
  imports: [RouterLink, RouterLinkActive, MatIconModule, TranslateModule],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
  standalone: true
})
export class SidenavComponent {
  parentRoute = input<'view' | 'pricing'>('view');
  routes = signal(sidenavRoutes);
}
